import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {useLoaderData, useNavigate} from "react-router-dom";
import {Container, Stack, Button, CardHeader, Avatar} from "@mui/material";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import closedChest from "../assets/fame.png";
import {red} from "@mui/material/colors";
import {format} from "date-fns";
import CardMedia from "@mui/material/CardMedia";
import dragon from "../assets/dragon.jpg";
import CardActions from "@mui/material/CardActions";
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';

export default function Games() {
    const games = useLoaderData();
    const navigate = useNavigate();

    return (
        <>
            <Container maxWidth="sm" sx={{
                display: 'flex',
                flexDirection: 'row',
                mb: 4,
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <img src={closedChest} alt={'closed chest'} width={60}/>
                <Typography variant="h5" align="center" color="text.secondary" paragraph sx={{ ml: 1 }}>
                    Mes parties
                </Typography>
            </Container>
            <Grid container spacing={4} sx={{ pl: 5, pr: 5, pt: 1 }} alignItems="center" justify="center"
                  direction="column">
                {games.map((game) => {
                    return (
                        <Grid item key={game} xs={12} sm={6} md={4}>
                            <Card sx={{ maxWidth: 345 }}>
                                <CardHeader
                                    avatar={
                                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                                            1
                                        </Avatar>
                                    }
                                    title={game.name}
                                    subheader={format(new Date(game.slot.scheduled_at), 'dd/MM/yyyy')}
                                />
                                <CardMedia
                                    component="img"
                                    height="194"
                                    src={dragon}
                                    alt="Paella dish"
                                />
                                <CardActions disableSpacing>
                                    <Button onClick={() => navigate(`/games/${game.id}`)}>
                                        <ManageHistoryIcon sx={{ mr: 1 }}/> Préparer
                                    </Button>
                                    <Button disabled>
                                        <SportsEsportsIcon sx={{ mr: 1 }}/> Jouer
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
            <Stack
                sx={{ pt: 4 }}
                direction="row"
                spacing={2}
                justifyContent="center"
            >
                <Button variant="contained" onClick={() => navigate('/slots')}>
                    <MonetizationOnIcon sx={{ mr: 1 }}/> Acheter une nouvelle partie
                </Button>
            </Stack>
        </>
    );
}
